export default "__VITE_ASSET__BbuLSySM__"